// extracted by mini-css-extract-plugin
export var arrow = "LinkWithArrow-module--arrow--OvTb5";
export var link = "LinkWithArrow-module--link--TSiWi";
export var text = "LinkWithArrow-module--text--axeHn";